module.exports = __webpack_public_path__ + "static/media/ministry_of_science.203d48d5.svg";